'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SheetContent, SheetHeader, SheetTitle } from '../../../../../../../../components/Sheet';
interface Props {
  children: React.ReactNode;
  title?: string;
  reset: () => void;
}
const FilterSheetContent = t0 => {
  const $ = _c(18);
  const {
    children,
    title,
    reset
  } = t0;
  const t = useTranslations("discover-sport-city");
  let t1;
  if ($[0] !== t) {
    t1 = t("reset-filters");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== reset || $[3] !== t1) {
    t2 = <button className="absolute left-0 underline" onClick={reset}>{t1}</button>;
    $[2] = reset;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t || $[6] !== title) {
    t3 = title || t("filters");
    $[5] = t;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <SheetTitle className="m-0 text-lg font-medium">{t3}</SheetTitle>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <SheetHeader className="relative mb-3 flex flex-row items-end justify-center">{t2}{t4}</SheetHeader>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children) {
    t6 = <div className="h-full overflow-y-scroll pb-10">{children}</div>;
    $[13] = children;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <SheetContent side="bottom" className="h-[70vh] bg-white">{t5}{t6}</SheetContent>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default FilterSheetContent;